<script setup>
import PdfViewer from '@/pages/components/templates/pdfViewer/PdfViewer.vue';
import { useRoute } from 'vue-router';
import { Capacitor } from '@capacitor/core';

const route = useRoute();

const apiUrl = route.query.apiUrl;
const params = JSON.parse(route.query.params || '{}');
const showHeader = Capacitor.isNativePlatform();
</script>

<template>
  <PdfViewer
    title=""
    :api-url="apiUrl"
    :params="params"
    :show-header="showHeader"
  />
</template>